import { ServiceInfos } from '@/state/thunks/cardReadThunk'
import { CouvertureDto } from 'src/common/interfaces'

export interface CardReaderDto {
  id: string
}

export async function getUrl(): Promise<CardReaderDto> {
  const url = process.env.REACT_APP_CARD_READER_URL
  console.log('url', url)
  if (!url) {
    throw new Error('REACT_APP_CARD_READER_URL is not defined')
  }
  try {
    const response = await fetch(url, {
      method: 'GET',
    })
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`)
    }
    const data: CardReaderDto = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}

export async function generateObjectHash(obj: CouvertureDto): Promise<string> {
  const { id, idPatient, ...relevantFields } = obj
  const sortedObj = Object.keys(relevantFields)
    .sort()
    .reduce((acc, key) => {
      acc[key] = relevantFields[key]
      return acc
    }, {} as Partial<CouvertureDto>)

  const objString = JSON.stringify(sortedObj)
  const msgUint8 = new TextEncoder().encode(objString)
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')

  return hashHex
}

export async function hasObjectChanged(
  originalHash: string,
  currentObj: CouvertureDto,
): Promise<boolean> {
  const currentHash = await generateObjectHash(currentObj)
  return originalHash !== currentHash
}

export async function getVitalCardResipUrl(
  cardReaderId: string,
  readDate: string,
  idResip: number,
): Promise<string> {
  const url = `${process.env.REACT_APP_API_URL}/billing/sesamvitale/lecture/LectureCarte?idResip=${idResip}&dateLecteur=${readDate}&idLecteur=${cardReaderId}&codeporteur=`

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const cardReadRes = (await response.json()) as {
      url: string
      erreur: boolean
      erreurCode: string
      erreurMessage: string
    }

    if (cardReadRes.erreurCode) {
      throw new Error(cardReadRes.erreurMessage)
    }

    return cardReadRes.url
  } catch (error) {
    throw error instanceof Error
      ? error
      : new Error('An unknown error occurred')
  }
}

export async function sendReaderResponse(
  visitId: number,
  readDate: string,
  cv: any,
): Promise<CouvertureDto> {
  const url = `${process.env.REACT_APP_API_URL}/billing/sesamvitale/sesamdb/getcouvertursummury?idVisit=${visitId}&dateLecture=${readDate}`
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(cv),
  })
  if (!response.ok) {
    throw new Error(`Network response was not ok: ${response.statusText}`)
  }
  const data: {
    error: string
    couverture: CouvertureDto
  } = await response.json()

  if (data.error) {
    return Promise.reject(data.error)
  }

  return data.couverture
}

export async function getCardReaderInfos(): Promise<ServiceInfos> {
  const url = process.env.REACT_APP_CARD_READER_URL

  if (!url) {
    throw new Error('Card reader URL is not defined')
  }

  const response = await fetch(url, {
    method: 'GET',
  })

  if (!response.ok) {
    throw new Error(`Network response was not ok: ${response.statusText}`)
  }

  const data = await response.json()

  return data
}
